import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  submit() {
    this.element.requestSubmit();
  }
}
